'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './servicerequest-ticket-edit.routes';

export class ServiceRequestTicketEditComponent {
  constructor(Auth, $state, $stateParams, dialogs, WorkOrderCodesService, ServiceRequestTicketsService, PropertyService, User, $uibModal) {
    'ngInject';

    this.ticketId = $stateParams.id;

    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.ServiceRequestTicketsService = ServiceRequestTicketsService;
    this.WorkOrderCodesService = WorkOrderCodesService;
    this.PropertyService = PropertyService;
    this.User = User;
    this.Auth = Auth;

    this.codes = [];
    this.codesEnum = [];
    this.schema = {};
    this.properties = [];

    this.WorkOrderCodesService.query(data => {
      this.codes = data;
      this.codesEnum = data.map(code => code.code);
    });

    this.PropertyService.query(data => {
      this.properties = data.map(property => {
        let address = "-";
        try {
          address = property.address.street + ', ' + property.address.city + ' ' + property.address.state + ', ' + property.address.zip;
        } catch(e){}

        return {
          value: property._id,
          name: address + ' / ' + property.lotNo,
          community: property.community.name
        }
      });
    });

    this.jsonValue = "";
    this.$state = $state;

    this.model = {};

    if (this.ticketId) {
      this.ServiceRequestTicketsService.get({id: this.ticketId}, data => {
        this.model = data;

        if (this.model.property)
          this.model.property = this.model.property._id;
      }, err => {
        console.log('Could not load service request ticket from server');
      })
    }

  }

  codeChanged () {
    let oCode = this.codes.find(code => code.code == this.model.code);

    if (!oCode)
      return;

    this.model.sequence = oCode.sequence;
    this.model.name = oCode.name;
    this.model.description = oCode.description;
    this.model.instructions = oCode.instructions;
  }

  propertyLookup() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'propertyLookup',
      resolve: {
        config: function() {
          return {}
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (property) {
        that.selectedProperty = property;
        that.model.property = property._id;
      },
      function () { /* cancel */ }
    );

  }

  create(form) {
    this.submitted = true;
    this.sendFailure = false;

    var that = this;

    if (form.$valid) {

      var onSuccess = () => {
        var actionString = (this.ticketId) ? "changed" : "created";
        var dlg = this.dialogs.notify("Success", "The service request ticket has been "+actionString+" successfully");
        dlg.result.then(() => {
          that.$state.go("servicerequest-ticket-list");
        });
      };

      var onError = err => {
        this.sendFailure = true;
      };

      if (this.ticketId) {  // Save changes on the current settings
        this.ServiceRequestTicketsService.update({id: this.ticketId}, this.model, onSuccess, onError);
      } else { // Create new settings
        this.model.meta = {creationUser: this.Auth.getCurrentUserSync()._id};
        this.ServiceRequestTicketsService.save(this.model, onSuccess, onError);
      }
    }
  }
}

export default angular.module('conduu.serviceRequestTicketEdit', [uiRouter])
  .config(routes)
  .component('serviceRequestTicketEdit', {
    template: require('./servicerequest-ticket-edit.html'),
    controller: ServiceRequestTicketEditComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/servicerequests/ticket-edit/servicerequest-ticket-edit.component.js